import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
import constants from '../constants/annotationConstants';
import { nativeBehaviorEvaluator } from '../nativeBehaviors/nativeBehaviorEvaluator';
import { configBehaviorsFunc } from '../nativeBehaviors/configBehaviors';
import contentChangeActionFactory from './factories/contentChangeActionFactory';
import { getStorage } from '../utils/storage';
const contentChangeActions = contentChangeActionFactory('form', 'forms');
const batchChange = changesArray => dispatch => {
  dispatch({
    type: constants.BATCH_CHANGE,
    payload: changesArray
  });
};
const clearEditorState = () => {
  // Clear from storage
  const storage = getStorage(JSON.parse(global.localStorage.getItem('user')));
  storage.removeItem('annotationEditorState');
  return {
    type: constants.CLEAR_EDITOR_STATE
  };
};
const loadAnnotations = () => async (dispatch, getState) => {
  dispatch({
    type: constants.LOAD
  });
  try {
    var _toolbar$annotationTo;
    const editorState = getState().annotation.editorState;
    const filters = editorState.filters,
      formID = editorState.formID,
      _editorState$toolbar = editorState.toolbar,
      toolbar = _editorState$toolbar === void 0 ? {} : _editorState$toolbar;
    if (!filters || Object.keys(filters).length === 0) {
      dispatch({
        type: constants.LOAD_FAILURE,
        payload: 'At least one filter must be specified to load annotations.'
      });
      return;
    }

    // Extract formTypeIdentifiers from toolbar array
    const formTypeIdentifiers = (_toolbar$annotationTo = toolbar.annotationTools) === null || _toolbar$annotationTo === void 0 ? void 0 : _toolbar$annotationTo.map(item => item.formTypeIdentifier);
    if ((formTypeIdentifiers === null || formTypeIdentifiers === void 0 ? void 0 : formTypeIdentifiers.length) > 0) {
      // Use queryFormBehavior through evaluateSource
      const querySource = {
        type: 'queryFormBehavior',
        formTypeIdentifiers,
        formID,
        filters,
        contentPaths: ['render', 'formType'],
        unsafeNoMaxLimit: true,
        // allows max limit (curreclty 200) to be overriden
        limit: 5000
      };

      // Set up the structures to call behaviors
      const evaluator = nativeBehaviorEvaluator.bind(null, {}, 'form');
      const nativeFunctions = {
        errorHandler: err => dispatch(contentChangeActions.nativeBehaviorError('form/behaviors.evaluateSource error', err)),
        evaluator,
        configBehaviors: configBehaviorsFunc
      };
      const annotations = await evaluateSource(querySource, {},
      // empty content object since we're querying
      '/',
      // root path since we're querying
      {},
      // context
      nativeFunctions);
      dispatch({
        type: constants.LOAD_SUCCESS,
        payload: annotations
      });
    } else {
      dispatch({
        type: constants.LOAD_SUCCESS,
        payload: []
      });
    }
  } catch (error) {
    dispatch({
      type: constants.LOAD_FAILURE,
      payload: error.message
    });
  }
};
const loadPersistedState = () => {
  const storage = getStorage(JSON.parse(global.localStorage.getItem('user')));
  const persistedState = storage.getItem('annotationEditorState');
  if (persistedState) {
    return {
      type: constants.LOAD_PERSISTED_STATE,
      payload: JSON.parse(persistedState)
    };
  }
  return {
    type: constants.CLEAR_EDITOR_STATE
  };
};
const setEditorState = editorState => {
  // Persist to storage
  const storage = getStorage(JSON.parse(global.localStorage.getItem('user')));
  storage.setItem('annotationEditorState', JSON.stringify(editorState));
  return {
    type: constants.SET_EDITOR_STATE,
    payload: editorState
  };
};
export default {
  batchChange,
  setEditorState,
  clearEditorState,
  loadAnnotations,
  loadPersistedState
};